@layer module {
.surface {
            display: flex;
            flex-flow: column nowrap;
            align-items: flex-start;
    }

.surface h3 {
            margin: 0;
    }

.card {
            width: 100%;
            border-width: 1px;
            border-style: solid;
    }

.amount-card {
            display: flex;
            flex-flow: column nowrap;
            align-items: flex-start;
    }

.footer {
            width: 100%;
            display: flex;
            justify-content: flex-end;
    }
} // layer module










@layer app {
.surface {
            max-width: $size-600;
            padding: $size-24 $size-20;
            gap: $size-20;
    }

.surface h3 {
            padding-right: $size-40;
    }

.card {
            border-radius: $size-12;
            padding: $size-16 $size-18;
    }

.amount-card {
            gap: $size-10;
    }

      @media (min-width: 480px) {
                .surface {
                        padding: $size-40;
                    }
          }

.surface {
            width: var(--modal-fill-inline-size);
    }

.surface h3 {
            font-size: var(--font-size-xl);
            line-height: $size-28;
            font-weight: 400;
    }

.card {
            background-color: var(--bg-modal);
            border-color: var(--border-default);
    }

.amount-card :global(.amount) {
            font-size: var(--font-size-xl);
            font-weight: 600;
            color: var(--text-primary);
    }
} // layer app
